import { ui } from "../../utils/ui";

const showLoader = () => ui?.loader && (ui.loader.hidden = false);

const hideLoader = () => ui?.loader && (ui.loader.hidden = true);

export { showLoader, hideLoader };
